export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            subjects: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        subjects(state) {
            return state.subjects.map((item, sl) => {
                item.sl = sl + 1;
                item.optional = item.is_optional == true ? 'Yes' : 'No';
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setSubject(state, subjects) {
            state.subjects = subjects
        },
    },

    actions: {
        async getSubjects(context, payload) {
            context.commit('setLoading', true);
        
            await axios.post(`${this.state.host}/get-subjects`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setSubject', res.data.subjects);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveSubject(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-subject';
            } else {
                url = 'add-subject';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getSubjects');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteSubject(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-subject/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getSubjects');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        }
    }
}